// Scroll
window.scrollTo(0, 0);

// Import custom modules
require('./navigation');
require('./carousel');
require('./icon');
require('./block-list');
require('./form-contact');
require('./notification')();
require('./accept-cookies')();

// Try to explain to foundation, that it should not equalize blocks, when they are stacked
Foundation.Equalizer.defaults.equalizeOnStack = false;

// Initialize foundation (we are using the equalizer)
$(window).load(function() {
  $(document).foundation();
});


/*****************
 ** WEBPACK FOOTER
 ** ./source/js/main.js
 ** module id = 0
 ** module chunks = 0
 **/